import OrbitApiV1 from 'api/orbitV1'
import { AxiosPromise } from 'axios'
import { GetAllGlobalUsers } from 'types/api/faber/globalCustomers.type'

class UsaAPI {
  static getAllGlobalUsers(body: {
    searchCriteria: string
    searchValue: string
    faberToken: string
  }): AxiosPromise<GetAllGlobalUsers> {
    let searchField = ''
    switch (body.searchCriteria) {
      case 'Email':
        searchField = 'email'
        break
      case 'MSISDN (users who signed up before 1 Nov 23)':
        searchField = 'msisdn'
        break
      case 'User ID':
        searchField = 'userid'
        break
      case 'Name':
        searchField = 'name'
        break
    }

    return OrbitApiV1.httpGet(
      `faber/user/auth0users?search=${searchField}&value=${body.searchValue.toLowerCase()}`,
      {
        Authorization: `Bearer ${body.faberToken}`
      }
    )
  }
}
export default UsaAPI
